import { supabase } from '../supabase';
import { safeSupabaseOperation } from './error-handler';

const bufferToBase64 = (buffer: ArrayBuffer | null): string => {
  if (!buffer) return '';
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

export const pushSubscriptionsService = {
  saveSubscription: async (userId: string, subscription: PushSubscription): Promise<boolean> => {
    const result = await safeSupabaseOperation(
      () =>
        supabase
          .from('push_subscriptions')
          .upsert(
            {
              user_id: userId,
              endpoint: subscription.endpoint,
              auth_key: bufferToBase64(subscription.getKey('auth')),
              p256dh_key: bufferToBase64(subscription.getKey('p256dh')),
            },
            { onConflict: 'endpoint' }
          ),
      'Error al guardar suscripción push'
    );

    return !result.error;
  },

  removeSubscription: async (endpoint: string): Promise<boolean> => {
    const result = await safeSupabaseOperation(
      () => supabase.from('push_subscriptions').delete().eq('endpoint', endpoint),
      'Error al eliminar suscripción push'
    );

    return !result.error;
  },
};

